/**
 * 呼び出し元画面に返却する情報を格納するVO
 */
export class KYMW1104OutputModel {

}
